






















import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      showInput: false
    };
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      default: 1000
    },
    min: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    size: {
      type: String //sm - md - lg
    },
    background: {
      type: Boolean
    },
    inputMode: {
      type: Boolean
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  methods: {
    showInputMethod() {
      if (this.inputMode) {
        this.showInput = true;
      }
    },
    inputChange(e) {
      let newVal;
      const inputChar = e.key;
      const isNumber = /[0-9]/.test(inputChar);
      const isBackspace = Boolean(e.which === 46);
      const isDelete = Boolean(e.which === 8);
      const oldValue: string = e.target.value;
      if (!isNumber && !isBackspace && !isDelete) {
        e.preventDefault();
        return false;
      }
      if (isNumber) {
        newVal = parseInt(oldValue + inputChar);
      } else {
        newVal = parseInt(oldValue.substr(0, oldValue.length - 1));
      }
      if (this.max && newVal > this.max) {
        newVal = this.max;
      } else if (newVal < this.min) {
        newVal = this.min;
      }
      setTimeout(() => this.$emit("change", newVal), 0);

      // const val: string = e.target.value;
      // const matched = /[0-9]/.test(val);
      // const isInteger = Boolean(+val === parseInt(val));

      // if (+val < this.min || +val > this.max || !isInteger || !matched) {
      //   e.preventDefault();
      //   return false;
      // }
      // this.$emit("change", +e.target.value);
    },
    validate() {
      if (this.max && this.value > this.max) {
        this.$emit("change", this.max);
      }
      if (this.value < this.min) {
        this.$emit("change", this.min);
      }
    },
    increment() {
      let value = this.value + this.step;
      if (this.max && value > this.max) {
        value = this.max;
      }
      this.$emit("change", value);
    },
    decrement() {
      let value = this.value - this.step;
      if (value < this.min) {
        value = this.min;
      }
      this.$emit("change", value);
    },
    cursorPosition(el: any) {
      let pos = 0;
      // Firefox support
      if (el.selectionStart || el.selectionStart == "0") {
        pos = el.selectionStart;
      }
      return pos;
    }
  },
  watch: {
    value() {
      this.validate();
    }
  }
});
